/**
 * Ticker is the yellow information banner top of the page.
 *
 * Information of ticker state is stored to local storage with 'hide-mn-ticker-<pid>'
 * where pid is Ticker database ticker PID number. This way each ticker has to be closed
 * individually.
 */
const TICKER_LOCALSTORAGE = 'hide-mn-ticker';

const carFreeSearch = document.querySelector('.car-search-top-section');

/**
 * Called when a ticker close button is clicked.
 * @param {event} event mouse click event object
 */
function onTickerCloseBtnClicked(event) {
  event.preventDefault();

  // Because of backend does not support multiple tickers
  // and because of ticker has id defined, use that id to close ticker
  const tickerElement = document.getElementById('mn-ticker');
  if(tickerElement) {
    const pid = tickerElement.dataset.pid;
    window.localStorage.setItem(`${TICKER_LOCALSTORAGE}-${pid}`, true);
    document.body.classList.remove('ticker--open');
    carFreeSearch?.classList?.remove('ticker--open');
  }
}

/**
 * Check is ticker element show or hidden
 * @return {boolean} true if ticker elemet is shown otherwise return false
 */
function isOpen() {
  const tickerElement = document.querySelector('.ticker');
  return tickerElement && !window.localStorage.getItem(`${TICKER_LOCALSTORAGE}-${tickerElement.dataset.pid}`);
}

/**
 * Ticker code is inialized each page load here.
 */
function init() {
  const tickerButtonElement = document.querySelector('a.close-ticker');

  if( tickerButtonElement ){
    tickerButtonElement.addEventListener( 'click', onTickerCloseBtnClicked );
  }

  if( isOpen() ) {
    document.body.classList.add('ticker--open');
    carFreeSearch?.classList?.add('ticker--open');
  }
}

export default {
  isOpen,
  init
}

export {
  isOpen,
  init
}
